module.exports = __webpack_public_path__ + "img/yingyb.781d8969.png";